import { NavLink } from 'react-router-dom';

// Config
import { ROUTES } from '../../../routes/routes';

// Styles
import styles from './Logo.module.scss';

const Logo = () => {
  return (
    <NavLink to={ROUTES.homePage.path} className={styles.wrapper}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="69"
        height="80"
        viewBox="0 0 69 80"
        fill="none"
        className={styles.logo}
      >
        <path
          d="M38.2509 2.12317V52.9107C38.2509 53.0687 38.1813 53.2187 38.0607 53.3208L35.0934 55.8316C34.8987 55.9963 34.6149 56.0015 34.4144 55.8439L31.2036 53.3211C31.074 53.2193 30.9983 53.0636 30.9983 52.8988V9.80553C30.9983 9.50883 30.7577 9.2683 30.4611 9.2683H9.61663C9.31993 9.2683 9.07941 9.50883 9.07941 9.80553V39.1733C9.07941 43.4992 10.009 47.8184 12.6207 51.2668C17.8908 58.2251 27.0689 67.0222 34.6978 68.5128C34.7389 68.5208 34.7749 68.5241 34.8167 68.5211C37.8886 68.2948 49.2555 60.9624 56.2185 51.2785C58.6993 47.8283 59.5251 43.5417 59.5251 39.2924V9.80553C59.5251 9.50883 59.2846 9.2683 58.9879 9.2683H45.987C45.6903 9.2683 45.4498 9.02777 45.4498 8.73107V2.12317C45.4498 1.82647 45.6903 1.58594 45.987 1.58594H66.7777C67.0744 1.58594 67.3149 1.82647 67.3149 2.12317V45.7461C66.2478 59.1072 45.5716 73.6978 34.9743 78.3691C34.8337 78.4311 34.6762 78.4247 34.537 78.3595C14.1058 68.7745 5.3951 56.994 2.05228 48.5963C1.31159 46.7356 1.07471 44.73 1.07471 42.7272V2.12317C1.07471 1.82647 1.31523 1.58594 1.61194 1.58594H37.7137C38.0103 1.58594 38.2509 1.82647 38.2509 2.12317Z"
          fill="url(#paint0_linear_93_3091)"
          stroke="url(#paint1_linear_93_3091)"
          strokeWidth="2.14891"
        />
        <defs>
          <linearGradient
            id="paint0_linear_93_3091"
            x1="-8.46067"
            y1="-26.6148"
            x2="91.3757"
            y2="51.2237"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#7ACFFF" />
            <stop offset="0.47" stopColor="white" />
            <stop offset="1" stopColor="#3E7C9F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_93_3091"
            x1="-1.94431"
            y1="-30.9323"
            x2="96.7044"
            y2="35.7995"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#7ACFFF" />
            <stop offset="0.47" stopColor="white" />
            <stop offset="1" stopColor="#3E7C9F" />
          </linearGradient>
        </defs>
      </svg>
      <p className={styles.text}>TMX</p>
    </NavLink>
  );
};

export default Logo;
